import { useMemo, useState } from "react";
import {
  Table,
  TableHead,
  TableCell,
  TableHeader,
  TableBody,
  TableRow,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { CustomActionDelete } from "../components/CustomActionDelete";
import { CustomActionToggle } from "../components/CustomActionToggle";
import { SMSTriggerEdit } from "./SMSTriggerEdit";
import { SMSTriggerCreate } from "./SMSTriggerCreate";
import { useCustomActions } from "../useCustomActions";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import { Heading } from "V2.0/common/heading";
import SMSTriggersTable from "./SMSTriggersTable";

function SMSTriggers(props) {
  const { customActions, assistantId, workspaceId, syncAssistant, locked } =
    props;
  const { customActionsArray, smsTriggersEnabled } = customActions;
  const {
    removeCustomAction,
    updateCustomAction,
    createCustomAction,
    toggleCustomAction,
  } = useCustomActions({ syncAssistant, workspaceId, assistantId });
  const [openEdit, setOpenEdit] = useState({
    isOpen: false,
    item: null,
    index: null,
  });
  const [openDelete, setOpenDelete] = useState({
    isOpen: false,
    item: null,
    index: null,
  });

  const smsTriggers = useMemo(() => {
    if (customActionsArray.length > 0) {
      return customActionsArray.filter(
        (action) => action.actionFunction === "SMS"
      );
    }

    return [];
  }, [customActionsArray]);

  const handleItemDelete = (lifecycleCbs) => {
    removeCustomAction(openDelete.item._id, lifecycleCbs);
  };

  const handleItemEdit = (data, lifecycleCbs) => {
    updateCustomAction(data, openEdit.item._id, lifecycleCbs);
  };

  const handleToggleCustomAction = (state) => {
    const loadingMessage = state
      ? "Enabling SMS Triggers.."
      : "Disabling SMS Triggers..";
    const successMessage = state
      ? "SMS Triggers enabled"
      : "SMS Triggers disabled";

    const lifecycleCbs = {
      init: () => {
        message.loading(loadingMessage);
      },
      success: () => {
        message.destroy();
        message.success(successMessage);
      },
      error: (e) => {
        message.destroy();
        showErrorToast(e, "Failed to update SMS Triggers");
      },
    };

    toggleCustomAction({ smsTriggersEnabled: state }, lifecycleCbs);
  };

  return (
    <>
      <div className="m-4 flex w-3/4 min-w-[600px] border rounded-lg flex-col gap-y-2">
        <div className="flex justify-between rounded-t-lg px-6 py-4 bg-gray-50 rounded-t-lg">
          <div className="flex items-center gap-x-2">
            <p className="text-md font-semibold text-gray-900">SMS Triggers</p>
            {!locked && (
              <CustomActionToggle
                isEnabled={smsTriggersEnabled}
                onToggleCustomAction={handleToggleCustomAction}
              />
            )}
          </div>
          {!locked && <SMSTriggerCreate onTriggerCreate={createCustomAction} />}
        </div>
        <div className="min-h-96 p-2">
          <SMSTriggersTable
            smsTriggers={smsTriggers}
            onEdit={setOpenEdit}
            onDelete={setOpenDelete}
            showActions={!locked}
          />
        </div>
      </div>
      {openDelete.isOpen && !locked && (
        <CustomActionDelete
          open={true}
          onClose={() =>
            setOpenDelete({ isOpen: false, item: null, index: null })
          }
          onDelete={handleItemDelete}
        />
      )}
      {openEdit.isOpen && !locked && (
        <SMSTriggerEdit
          open={true}
          onClose={() =>
            setOpenEdit({ isOpen: false, item: null, index: null })
          }
          onTriggerEdit={handleItemEdit}
          smsTrigger={openEdit.item}
        />
      )}
    </>
  );
}

export { SMSTriggers };
